import React from "react";
import {DefaultProps, PaginatedLoad, RefTable, Validator} from "../RefTable";
import {SpecialTerritoryPostalCode} from "../SpecialRerritoryPostalCode";
import {Button, Modal} from "antd";

const ViewPostalCode = (props) => {

    const [opt, setOpt] = React.useState({special_territory_id : undefined,
        special_territory_name: undefined, country_code: undefined, openItem: false});

    return <React.Fragment>
        <Modal
            key = {opt.openItem}
            centered
            width="80vw"
            closable={true}
            onCancel={() => {
                setOpt({special_territory_id : undefined, special_territory_name: undefined, country_code: undefined, openItem: false });
            }}
            footer={null}
            title={`Postal Codes for ${opt.special_territory_name}`}
            visible={opt.openItem}
        >
            <SpecialTerritoryPostalCode
                special_territory_id = {opt.special_territory_id}
                country_code = {opt.country_code}
            />
        </Modal>
        <Button onClick={()=>{setOpt({special_territory_id : props.value, special_territory_name: props.row.special_territory_name,
            country_code: props.row.country_code, openItem: true}) }}>View</Button>
    </React.Fragment>

}

export const SpecialTerritories  = (props)=><RefTable {...props}/>;

SpecialTerritories.defaultProps = {
    ...DefaultProps,
    tableName: "special_territory",
    tableSchema: "special_territory",
    edit: true,
    filterSchema: "special_territory_filter",
    title: "Special VAT Territories",
    tfootHeight: 50,
    theadHeight: 62,
    headerChildHeight: 125,
    validator: {
        vat_rate: new Validator("vat_rate", async (value)=> {
            if(value < 0 )
                return Promise.reject("VAT Rate cannot be negative")
        })
    },
    fetch: PaginatedLoad,
    enrichColumns: async (columns) => {
        return [
            {
                name: "id",
                title: "Postal Codes",
                width: 260,
                formatter: (row, index, name, type, formatted, value) => <ViewPostalCode key={index} value={value} row={row}/>
            }, ...columns]
    }

}